/*
 * @Author: your name
 * @Date: 2020-04-17 15:45:43
 * @LastEditTime: 2020-07-29 16:47:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \musicshop_resource\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

//引入公共url头部
import publicLink from './components/publicLink/publicLink'

//引入字体图标
import './assets/css/iconfont.css'
Vue.prototype.publicLink = publicLink.serverPath

router.beforeEach((to, from, next) => {
  //NProgress.start();

  console.log(to.path)
  console.log(to)
  if (to.path == '/login') {
    sessionStorage.removeItem('access_token')
    // sessionStorage.removeItem("expired_at");
  } else {
    let access_token = sessionStorage.getItem('access_token')
    // let expired_at = sessionStorage.getItem("expired_at");
    // if (!access_token) {
    //   if (to.path == "/noMenu/selectedSongDetail") {
    //     next();
    //     return;
    //   }
    //   if (to.path == "/sellSong/sell" || to.path == "/sellsong/sell") {
    //     next({
    //       path: "/login?redirect=" + encodeURIComponent("/sellSong/sell")
    //     });
    //   } else {
    //     next({
    //       path: "/login?redirect=" + encodeURIComponent(to.fullPath)
    //     });
    //   }
    // } else {
    //   next();
    // }
  }

  next()
})

// 设置设备唯一标识
let cookieUuid = ''
var strCookie = document.cookie
var arrCookie = strCookie.split('; ')
for (var i = 0; i < arrCookie.length; i++) {
  var arr = arrCookie[i].split('=')
  if (arr[0] == 'uuid') cookieUuid = arr[1]
}
if (cookieUuid != '') {
  localStorage.setItem('uuid', cookieUuid)
} else {
  console.log('重新获取')
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  localStorage.setItem('uuid', uuid)
  var exp = new Date()
  exp.setTime(exp.getTime() + 1000 * 60 * 60 * 24 * 365) //这里表示保存一年
  document.cookie = 'uuid=' + uuid + ';expires=' + exp.toGMTString()
  // return uuid;
}

Vue.http.headers.common["Device-Origin"] = "7";
Vue.http.headers.common['Device-Token'] = localStorage.getItem('uuid')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js